import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

interface RequireAnyPermissionProps {
  permissions: string[]
  children: ReactNode
  redirectTo?: string
}

/** Route guard when any one of several permission codes is sufficient. */
export default function RequireAnyPermission({
  permissions,
  children,
  redirectTo = '/dashboard',
}: RequireAnyPermissionProps) {
  const { hasPermission, loading } = useAuth()
  if (loading) return null
  if (!permissions.some(hasPermission)) return <Navigate to={redirectTo} replace />
  return <>{children}</>
}
